var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyLiveClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1385_513)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_1385_513)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.723 11.0991C15.4083 10.6963 15.1062 10.3312 14.8167 9.96617C14.5775 9.66407 14.3258 9.36197 14.0866 9.04728C13.86 8.74518 13.8852 8.38014 14.1621 8.15357C14.4391 7.92699 14.8041 7.97734 15.0433 8.26686C15.6349 9.00952 16.2265 9.75219 16.8181 10.4823C16.8685 10.5578 16.9314 10.6207 17.0069 10.7088C17.2838 10.369 17.5356 10.0417 17.7999 9.71442C18.1901 9.22351 18.5804 8.73259 18.9832 8.24168C19.1468 8.04028 19.3482 7.96475 19.5999 8.01511C19.8265 8.06546 19.9902 8.20392 20.0531 8.43049C20.1286 8.65707 20.0531 8.85847 19.9146 9.0347C19.4237 9.65149 18.9328 10.2683 18.4419 10.8851C18.4041 10.9354 18.3664 10.9984 18.3034 11.0739C18.7062 11.0739 19.0713 11.0739 19.4363 11.0739C20.4055 11.0739 21.337 11.2249 22.2182 11.6403C23.7412 12.3578 24.6727 13.541 24.9497 15.2152C24.9874 15.4543 25 15.7187 25 15.9578C25 17.204 25 18.4628 25 19.7089C25 22.4027 23.0238 24.7062 20.3552 25.1467C20.0783 25.1971 19.7762 25.2223 19.4992 25.2223C17.8377 25.2223 16.1635 25.2223 14.502 25.2223C11.8208 25.2223 9.50474 23.246 9.07677 20.5901C9.02642 20.3005 9.00124 19.9859 9.00124 19.6963C9.00124 18.5131 9.01383 17.3299 9.00124 16.1341C8.95089 13.7298 10.4362 11.9298 12.6894 11.3005C13.3691 11.1116 14.074 11.0487 14.7789 11.0613C15.081 11.0613 15.3705 11.0613 15.7104 11.0613L15.723 11.0991ZM17.0069 12.3326C16.2013 12.3326 15.3957 12.3075 14.5901 12.3326C14.0866 12.3578 13.5831 12.4082 13.0922 12.5214C11.5313 12.9117 10.1971 14.0319 10.2348 16.2096C10.26 17.3551 10.2348 18.4879 10.2348 19.6334C10.2348 19.9607 10.26 20.288 10.3355 20.6026C10.7887 22.6418 12.5006 24.0139 14.5901 24.0139C16.1887 24.0139 17.7999 24.0139 19.3985 24.0139C19.6125 24.0139 19.8391 24.0013 20.0531 23.9761C22.1049 23.7118 23.7161 21.9495 23.7664 19.8474C23.8042 18.5257 23.7916 17.1914 23.7664 15.8697C23.7412 14.7494 23.2881 13.8305 22.3566 13.1634C21.5007 12.5466 20.5062 12.3326 19.4741 12.32C18.6559 12.32 17.8377 12.32 17.0069 12.32V12.3326Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1567 17.8702C15.1567 17.266 15.1567 16.6618 15.1567 16.0576C15.1567 15.5289 15.6477 15.2394 16.1008 15.5037C17.1204 16.1079 18.14 16.7121 19.147 17.3289C19.575 17.5932 19.575 18.1345 19.147 18.3988C18.14 19.0156 17.1204 19.6198 16.1008 20.224C15.6477 20.4884 15.1567 20.1989 15.1567 19.6702C15.1567 19.066 15.1567 18.4618 15.1567 17.8576V17.8702Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1385_513",
    x: -30,
    y: -30,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1385_513"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1385_513",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1385_513",
    x1: 2.26667,
    y1: 2.26667,
    x2: 51.0398,
    y2: 64.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLiveClasses);
export default __webpack_public_path__ + "static/media/MyLiveClasses.8e3ce3a00e3cd63b0ba56e2bc4bbccda.svg";
export { ForwardRef as ReactComponent };